import * as React from "react";
import { useDebouncedEffect, useScrollIntoView } from "@grandvisionhq/utils";
const Delayed = ({
  delay,
  scrollIntoView = false,
  className,
  children
}) => {
  const [visibility, setVisibility] = React.useState(false);
  useDebouncedEffect(() => setVisibility(true), delay);
  const { elementRef, triggerScroll } = useScrollIntoView();
  React.useEffect(() => {
    if (scrollIntoView && visibility) {
      triggerScroll();
    }
  }, [scrollIntoView, triggerScroll, visibility]);
  return /* @__PURE__ */ React.createElement("div", { className, ref: elementRef }, visibility && children);
};
export {
  Delayed
};
//# sourceMappingURL=Delayed.js.map
